
import { legacy_createStore as createStore, applyMiddleware } from "redux";
import type { Reducer, UnknownAction } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistReducer, persistStore } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import rootReducer from "@/AppRedux/reducers";
import type { RootState } from "@/AppRedux/reducers";
import rootSaga from "@/AppRedux/sagas";
import persistConfig from "./persistConfig";

const sagaMiddleware = createSagaMiddleware();
const persistedReducer = persistReducer<RootState, UnknownAction>(
  { ...persistConfig, storage: storageSession },
  rootReducer as unknown as Reducer<RootState, UnknownAction>,
);

export const store = createStore(persistedReducer, applyMiddleware(sagaMiddleware));
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
